import { FC, memo } from "react";
import FormattedNumber from "../FormattedNumber";
const AmountDisplay: FC<{ value: number }> = memo(({ value }) => {
    return (
        <div
            className="flex items-center gap-2 p-1 rounded-md bg-card w-fit pr-2 text-white text-sm overflow-hidden"
            style={{
                backgroundColor: "#3B3E43B2",
                borderRadius: "46px",
                borderColor: "#4C4F55B2",
                borderWidth: "1px",
            }}
        >
            <img src="/images/jettonFallback.svg" alt="" width={20} height={20} className="rounded-full" />
            <FormattedNumber value={value} />
        </div>
    );
});

AmountDisplay.displayName = "AmountDisplay";

export default AmountDisplay;
